import { Map } from 'immutable'
import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'

import * as actions from './actions'

const integrations = handleActions(
  {
    [combineActions(
      actions.fetchIntegrationStatesPending,
      actions.updateIntegrationStatePending
    )]: (state, action) => {
      return state.set('connectionsStatus', action.type)
    },
    [actions.fetchIntegrationStatesSuccess]: (state, action) => {
      return state
        .set('connections', action.payload)
        .set('connectionsStatus', action.type)
    },
    [actions.updateIntegrationStateSuccess]: (state, action) => {
      return state.set('connections', action.payload)
    },
    [actions.setWordpressV2IntegrationSuccess]: (state, action) => {
      return state.set('connections', action.payload)
    },
    [combineActions(
      actions.createAccessTokenSuccess,
      actions.createAccessTokenPending,
      actions.createAccessTokenFailed
    )]: (state, action) => {
      return state.setIn(
        ['accessToken', action.payload.integrationName, 'status'],
        action.type
      )
    },
    [actions.createAccessTokenFailed]: (state, action) => {
      return state.setIn(
        ['accessToken', action.payload.integrationName, 'error'],
        action.payload.err
      )
    },
    [combineActions(
      actions.fetchFacebookSettings,
      actions.fetchFacebookSettingsCancelled,
      actions.fetchFacebookSettingsFailed,
      actions.fetchFacebookSettingsPending,
      actions.fetchFacebookSettingsSuccess
    )]: (state, action) =>
      state.setIn(['facebookSettings', 'status'], action.type),
    [actions.fetchFacebookSettingsSuccess]: (state, action) =>
      state.setIn(['facebookSettings', 'data'], action.payload),
    [combineActions(
      actions.fetchStripeKeys,
      actions.fetchStripeKeysCancelled,
      actions.fetchStripeKeysFailed,
      actions.fetchStripeKeysPending,
      actions.fetchStripeKeysSuccess
    )]: (state, action) => state.setIn(['stripeKeys', 'status'], action.type),
    [actions.fetchStripeKeysSuccess]: (state, action) =>
      state.setIn(['stripeKeys', 'data'], action.payload),
    [combineActions(
      actions.fetchOutreachStatus,
      actions.fetchOutreachStatusFailed,
      actions.fetchOutreachStatusPending,
      actions.fetchOutreachStatusSuccess
    )]: (state, action) =>
      state.setIn(['outreachStatus', 'status'], action.type),
    [actions.fetchOutreachStatusSuccess]: (state, action) =>
      state.setIn(['outreachStatus', 'data'], Map(action.payload)),
    [combineActions(
      actions.getLeanDataAuthStatusFailed,
      actions.getLeanDataAuthStatusPending
    )]: (state, action) => {
      return state.setIn(
        ['leanDataAuthStatus', 'status'],
        action.type.toString()
      )
    },
    [actions.getLeanDataAuthStatusSuccess]: (state, action) => {
      return state
        .setIn(['leanDataAuthStatus', 'status'], action.type.toString())
        .setIn(['leanDataAuthStatus', 'value'], action.payload.authStatus)
    },
    [actions.getLeanDataAuthStatus]: (state) => {
      return state
    },
  },
  Map()
)

const wordpressIntegrationDomain = handleActions(
  {
    [actions.setWordpressDomainSuccess]: (state) => {
      return state.setIn(['error'], false)
    },

    [actions.setWordpressDomain]: (state, action) => {
      return state
        .setIn(['rootUrl'], action.payload.rootUrl)
        .setIn(['error'], false)
    },

    [actions.fetchWordpressDomainSuccess]: (state, action) => {
      return state.setIn(['rootUrl'], action.payload.rootUrl)
    },

    [actions.setWordpressDomainFailed]: (state, action) => {
      return state.setIn(['error'], action.payload.error)
    },
  },
  Map({
    rootUrl: '',
    error: false,
  })
)

export default combineReducers(integrations, wordpressIntegrationDomain)
